import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { Box } from '@mui/material';
import type { SxProps } from '@mui/material';
import { sizes } from '../../styles/sizes';

// the only spacing component you need
// use this instead of margin
export const Space: React.FC<React.PropsWithChildren<{
  space: keyof typeof sizes.raw;
  sx?: SxProps;
}>> = t0 => {
  const $ = _c(6);
  const {
    space,
    sx,
    children
  } = t0;
  const t1 = sizes.pixels[space];
  let t2;
  if ($[0] !== sx || $[1] !== t1) {
    t2 = {
      gap: t1,
      ...sx
    };
    $[0] = sx;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <Box sx={t2}>{children}</Box>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};